// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Field errors and the validation checklist ease in/out, as without an animation the DOM can shift too fast
for user interactions to hit the proper target. A single-row grid animating 0fr <-> 1fr interpolates to the
content height, so no height cap clips longer content. */
.FieldValidation-module__Collapsible__b1wAx {
    display: grid;
    grid-template-rows: 1fr;
}

.FieldValidation-module__CollapsibleContent__yrkih {
    /* Lets the grid item shrink below its content size */
    min-height: 0;
    overflow: hidden;
}

.FieldValidation-module__Checklist__J0Xh9 {
    transition:
        grid-template-rows var(--ds-transition-m) ease-in,
        visibility var(--ds-transition-m) linear;
}

.FieldValidation-module__ClientError__U61EQ {
    transition:
        grid-template-rows var(--ds-transition-s) ease-in,
        visibility var(--ds-transition-s) linear;
}

.FieldValidation-module__TransitionDelay__ojYGd {
    transition-delay: var(--ds-transition-m);
}

.FieldValidation-module__Hidden__V9JMv {
    grid-template-rows: 0fr;
    visibility: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Collapsible": `FieldValidation-module__Collapsible__b1wAx`,
	"CollapsibleContent": `FieldValidation-module__CollapsibleContent__yrkih`,
	"Checklist": `FieldValidation-module__Checklist__J0Xh9`,
	"ClientError": `FieldValidation-module__ClientError__U61EQ`,
	"TransitionDelay": `FieldValidation-module__TransitionDelay__ojYGd`,
	"Hidden": `FieldValidation-module__Hidden__V9JMv`
};
export default ___CSS_LOADER_EXPORT___;
